import { Link } from "react-router-dom";
import { categories } from "@/mocks/news";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.id}`}
          className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-3 py-5 transition-all hover:-translate-y-0.5 hover:border-primary-300 hover:bg-background-100"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${cat.icon} text-2xl`} />
          </span>
          <span className="text-sm font-medium text-foreground-800">{cat.name}</span>
        </Link>
      ))}
    </div>
  );
}